import React from 'react';
import { Component } from "react";
import { API_URL } from '../urls';
import DefaultLayout from "../layouts/Default";
require('odatajs');

class ViewStaticPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      pending: true,
      data: { Id: props.id, Name: props.name }
    };

    if(props.match && props.match.params){
      this.state.data.Id = props.match.params.id;
      this.state.data.Name = props.match.params.name;
    }
  }

  componentDidMount() {
    document.title = "Loading...";
      window.odatajs.oData.read(API_URL + 
        (this.state.data.Id
          ? ("StaticPages(" + this.state.data.Id + ")")
          : ("StaticPages/?$filter=name%20eq%20%27" + encodeURI(this.state.data.Name) + "%27")),
            (data) => {
          	this.setState({
	            pending: false,
              data: (data.value ? data.value[0] : data)
	        });
            },
            (error) => {
                if(error.response.statusCode === 401){
                  window.location.href = "/login";
                }
          	this.setState({
	            pending: false,
        	    error
	        });
            }
        );
    }

    render() { 
	const { error, pending, data } = this.state;
	if (error) {
      		return <div>Error: {error.message}</div>;
	} else if (pending) {
		return <div>Loading...</div>;
	} else {
	        return (
<DefaultLayout>
  <div dangerouslySetInnerHTML={{ __html: data.Body }} />
</DefaultLayout>
		);
	}
    }
}
 
export default ViewStaticPage;